<template>
  <el-dialog
    class="order-info-dialog"
    @close="onClose"
    :top="isMobile ? '0' : '20vh'"
    :close-on-click-modal="true"
    :show-close="showClose"
    :class="{ mobile_dialog: isMobile, order: process === 'pay' }"
    :width="!isMobile ? (currentLang === 1 ? '500px' : '450px') : '100vw'"
    height="300px"
    :visible.sync="dialogVisible"
    center
    append-to-body
  >
    <div class="work-info" v-if="process === 'ordering'">
      <div class="cover">
        <img :src="goodsObj.cover" />
      </div>
      <div class="info">
        <div class="title" v-html="payForFullContent"></div>
        <div class="detail">
          <div class="item">
            <span>{{ languageOption.price }}&nbsp;&nbsp;</span>
            <span class="red">￥{{ type === 'article' && goodsObjListIndex === 0 ? goodsObj.articlePrice : goodsObj.price }}</span>
          </div>
          <div class="item">
            <span>{{ languageOption.validity }}&nbsp;&nbsp;</span>
            <span>{{ goodsObj.period === 0 ? languageOption.permanent : goodsObj.period + languageOption.nMonths }}</span>
          </div>
        </div>
        <div class="button" :class="{ bottom1: goodsObjList.length < 2 && type !== 'article', en: currentLang === 1 }">
          <el-button @click="orderGoods">{{ languageOption.subscribeNow }}</el-button>
          <el-button @click="collect">{{ languageOption.addToFavorites }}</el-button>
        </div>
        <div class="button1" v-if="goodsObjList.length > 1 && type !== 'article'" :class="{ en: currentLang === 1 }">
          <el-button :disabled="goodsObjListIndex === 0" @click="changeGoods('prev')" :class="{ disabled: goodsObjListIndex === 0 }"> {{ currentLang === 1 ? 'Previous' : '上一个商品' }}</el-button>
          <el-button :disabled="goodsObjListIndex === goodsObjList.length - 1" @click="changeGoods('next')" :class="{ disabled: goodsObjListIndex === goodsObjList.length - 1 }">{{
            currentLang === 1 ? 'Next' : '下一个商品'
          }}</el-button>
        </div>
        <div class="button1" v-if="type === 'article' && goodsObj.articlePrice && goodsObj.articlePrice !== ''" :class="{ en: currentLang === 1 }">
          <el-button :disabled="goodsObjListIndex === 0" @click="goodsObjListIndex = 0" :class="{ disabled: goodsObjListIndex === 0 }"> {{ currentLang === 1 ? 'Previous' : '上一个商品' }}</el-button>
          <el-button :disabled="goodsObjListIndex === 1" @click="goodsObjListIndex = 1" :class="{ disabled: goodsObjListIndex === 1 }">{{ currentLang === 1 ? 'Next' : '下一个商品' }}</el-button>
        </div>
      </div>
    </div>
    <div class="order-info" v-if="process === 'pay'">
      <div class="goods">
        <div class="cover">
          <img :src="goodsObj.cover" />
        </div>
        <div class="title">
          <div>{{ languageOption.welcomeToSubscribe }}</div>
          <div>{{ goodsObj.worksName }}</div>
        </div>
      </div>
      <div class="order">
        <span>{{ languageOption.orderNumber }}：{{ order.orderSn }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>{{ languageOption.orderPrice }}：{{ order.totalAmount }}</span>
      </div>
      <div class="pay-option">
        <span>{{ languageOption.paymentTip }}：</span>
        <el-radio v-model="payWay" :label="2">
          <img src="@imgs/toolbar/wechatPay-icon.png" />
        </el-radio>
        <el-radio v-model="payWay" :label="1" v-show="!isMobile">
          <img src="@imgs/aplipay_vip.png" />
        </el-radio>
      </div>
      <!--<div v-if="!isMobile" class="note">*选择支付宝支付，请通过浏览器打开进行支付。</div>-->
      <div class="button">
        <el-button @click="goPay">{{ languageOption.goToPayment }}</el-button>
      </div>
    </div>
    <div class="processing" v-if="process === 'paying' && !isMobile">
      <div class="title">{{ payWay === 1 ? (currentLang === 1 ? 'Alipay' : '支付宝支付') : currentLang === 1 ? 'WeChat Pay' : '微信支付' }}</div>
      <vue-qr :text="qrCodeUrl" :size="88" :margin="5" />
      <p>{{ currentLang === 1 ? 'Please scan the QR code on your mobile phone for payment' : '请手机扫描二维码支付' }}</p>
    </div>
    <div class="processing" v-if="process === 'paying' && isMobile">
      <p>{{ currentLang === 1 ? 'Please wait a moment' : '支付确认中，请稍等片刻。' }}</p>
      <img src="@imgs/toolbar/loading.gif" />
    </div>
    <div class="processing" v-if="process === 'payed'">
      <p>{{ currentLang === 1 ? 'Thank you for your subscription' : '订单完成，感谢您的订阅。' }}</p>
      <div class="button">
        <el-button @click="reload">{{ currentLang === 1 ? 'Start Reading' : '开始阅读' }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import chargeApi from '@api/chargeManager'
import apis from '@api/getBook'
import bookshelfDetail from '@api/bookshelfDetail'
import { isLogin } from '@/utils'
import user from '@api/login'
import VueQr from 'vue-qr'
export default {
  name: 'OrderDialog',
  data() {
    return {
      dialogVisible: false,
      process: 'ordering',
      payWay: 2,
      order: {},
      qrCodeUrl: '',
      goodsObjListIndex: 0,
      statusTimer: null,
      goodsObj: { ...this.$store.state.common.goodsObj }
    }
  },
  props: {
    type: {
      default: 'book',
      type: String
    },
    articleId: {
      default: ''
    },
    ebookId: {
      default: ''
    }
  },
  components: { VueQr },
  computed: {
    workType() {
      switch (this.$route.name) {
        case 'paperDefault':
          return 'cloud_read_epaper'
        case 'bookshelfDetail':
          return 'cloud_read_album'
        default:
          return 'cloud_read_ebook'
      }
    },
    showClose() {
      return this.workType !== 'cloud_read_ebook' || (this.goodsObj.chargePage > 0 && (!this.isMobile || (this.isMobile && (this.process === 'pay' || this.process === 'ordering'))))
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    userName() {
      return localStorage.getItem('username')
    },
    goodsObjList() {
      return this.$store.state.common.goodsObjList
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    currentLang() {
      const type = this.type === 'article' ? 'book' : this.type
      return this.$store.state.config[type + 'Obj'].language
    },
    payForFullContent() {
      if (this.currentLang === 1) {
        const content = this.type !== 'article' && this.goodsObj.worksType === 'cloud_read_album' ? 'collection' : this.type === 'article' && this.goodsObjListIndex === 0 ? 'article' : 'content'
        return `Pay for full ${content}`
      } else {
        const content = this.type !== 'article' && this.goodsObj.worksType === 'cloud_read_album' ? '专辑' : this.type === 'article' && this.goodsObjListIndex === 0 ? '文章' : '书刊'
        return `付费订阅 <br />阅读完整${content}内容`
      }
    }
  },
  methods: {
    async orderGoods() {
      await isLogin()
      let param =
        this.type === 'article' && this.goodsObjListIndex === 0
          ? {
              articleId: this.articleId,
              ebookId: this.ebookId,
              userName: localStorage.getItem('username')
            }
          : {
              userName: localStorage.getItem('username'),
              worksId: this.goodsObj.worksId,
              worksType: this.goodsObj.worksType
            }
      let orderApi = this.type === 'article' && this.goodsObjListIndex === 0 ? chargeApi.addArticleOrder : chargeApi.addOrder
      orderApi(param).then((res) => {
        let data = res.data.data
        if (data) {
          this.order = data.order
          this.order.name = data.orderItemList[0].productName
          this.process = 'pay'
        } else {
          this.$message({
            message: res.data.message || '创建订单失败',
            type: 'error'
          })
        }
      })
      if (this.isMobile) {
        this.payWay = 2
      }
    },
    collect() {
      this.$emit('collect', 'order')
    },
    goPay() {
      if (!this.payWay || this.payWay === '') {
        this.$message({
          message: this.languageOption.paymentTip,
          type: 'error'
        })
        return
      }
      let param = {
        orderCode: this.order.orderSn,
        payID: this.payWay
      }
      const accessCode = this.$route.query.accessCode || localStorage.getItem('accessCode')
      if (!this.isMobile) {
        chargeApi.getPayQRCode(param).then((res) => {
          if (res.data.status === 0) {
            this.qrCodeUrl = res.data.data.qrCodeUrl
            this.process = 'paying'
            this.statusTimer = setInterval(this.getPayStatus, 2000)
          } else {
            this.$message({
              message: '请求失败，请刷新重试',
              type: 'error'
            })
          }
        })
      } else {
        if (accessCode && accessCode !== '') {
          this.qizhiPay(accessCode)
        } else {
          let ua = window.navigator.userAgent.toLowerCase()
          let isWx = ua.match(/MicroMessenger/i) == 'micromessenger'
          if (isWx) {
            //微信浏览器付费接口
            param.openId = localStorage.getItem('openId')
            if (!param.openId) {
              window.location.href = window.PROJECT_CONFIG.BASE_URL + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
              return
            }
            let _this = this
            chargeApi.wxJSAPIPay(param).then((res) => {
              if (res.data.status === 0 && res.data.data) {
                let jsApiSetting = res.data.data.jsapiResut
                if (typeof WeixinJSBridge == 'undefined') {
                  if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', _this.onBridgeReady(jsApiSetting), false)
                  } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady(jsApiSetting))
                    document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady(jsApiSetting))
                  }
                } else {
                  this.onBridgeReady(jsApiSetting)
                }
                this.process = 'paying'
                this.statusTimer = setInterval(this.getPayStatus, 2000)
              } else {
                this.$message({
                  message: '请求失败，请刷新重试',
                  type: 'error'
                })
              }
            })
          } else {
            chargeApi.wxH5Pay(param).then((res) => {
              if (res.data.status === 0) {
                if (res.data.data) {
                  let a = document.createElement('a')
                  a.setAttribute('href', res.data.data.h5Result)
                  a.target = '_blank'
                  a.click()
                  a.remove()
                }
                this.process = 'paying'
                this.statusTimer = setInterval(this.getPayStatus, 2000)
              } else {
                this.$message({
                  message: '请求失败，请刷新重试',
                  type: 'error'
                })
              }
            })
          }
        }
      }
    },
    onBridgeReady(jsApiSetting) {
      WeixinJSBridge.invoke('getBrandWCPayRequest', jsApiSetting, function(res) {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          this.process = 'payed'
          clearInterval(this.statusTimer)
        } else {
          this.$message({
            message: '支付失败，请刷新重试',
            type: 'error'
          })
        }
      })
    },
    getPayStatus() {
      let param = {
        orderCode: this.order.orderSn,
        payID: this.payWay
      }
      chargeApi.queryOrderStatus(param).then((res) => {
        if (res.data.status === 0) {
          this.$store.commit('common/UPDATE_IS_ORDERED', true)
          this.process = 'payed'
          clearInterval(this.statusTimer)
        }
      })
    },
    async qizhiPay(accessCode) {
      if (window.$bridge) {
        let phone = localStorage.getItem('qizhiPhone')
        if (!phone || phone == 'null') {
          await user.getQizhiUserInfo(accessCode).then((res) => {
            if (res.data.status === 0 && res.data.data) {
              phone = res.data.data.phone
            }
          })
        }
        window.$bridge.callhandler(
          'weixinPay',
          {
            orderNo: this.order.orderSn,
            orderAmount: this.type === 'article' && this.goodsObjListIndex === 0 ? this.goodsObj.articlePrice : this.goodsObj.price,
            productName: this.order.name,
            paymentMethod: this.payWay,
            mobile: phone
          },
          (response) => {
            alert('桥接成功')
            alert('桥接返回值：' + response.data + response.status)
            if (response.status === 'success') {
              this.qizhiOrderPayAuth(response.data)
            } else {
              alert('支付失败')
            }
          }
        )
      } else {
        alert('桥接失败')
      }
    },
    qizhiOrderPayAuth(data) {
      chargeApi
        .qizhiOrderPayAuth({
          orderCode: this.order.orderSn,
          payStatus: 1,
          accessCode: this.$route.query.accessCode,
          qiZhiPhone: localStorage.getItem('qizhiPhone')
        })
        .then((res) => {
          alert('qizhiOrderPayAuth接口返回值：' + res.data.status)
          if (res.data.status === 0) {
            this.process = 'payed'
            this.$store.commit('common/UPDATE_IS_ORDERED', true)
          }
        })
    },
    changeGoods(type) {
      if (type === 'prev' && this.goodsObjListIndex <= 0) {
        return
      }
      if (type === 'next' && this.goodsObjListIndex >= this.goodsObjList.length - 1) {
        return
      }
      if (type === 'prev' && this.goodsObjListIndex > 0) {
        this.goodsObjListIndex--
      }
      if (type === 'next' && this.goodsObjListIndex < this.goodsObjList.length - 1) {
        this.goodsObjListIndex++
      }
      if (this.goodsObjList[this.goodsObjListIndex].worksType === 'cloud_read_album') {
        bookshelfDetail.bookshelfMobileDetail({ id: this.goodsObjList[this.goodsObjListIndex].worksId }).then((res) => {
          if (res.data.data?.cover) {
            this.goodsObj.cover = res.data.data.cover
          } else if (res?.data?.data.ebookList && res.data.data.ebookList.length > 0) {
            this.goodsObj.cover = res.data.data.ebookList[0].coverUrl
          }
        })
      } else {
        apis.GetMobileBookDetails({ id: this.goodsObjList[this.goodsObjListIndex].worksId }).then((res) => {
          if (res?.data.data) {
            let data = res.data.data
            let cover = data.path + '/1.jpg'
            this.goodsObj.cover = cover
          }
        })
      }
      this.goodsObj.worksId = this.goodsObjList[this.goodsObjListIndex].worksId
      this.goodsObj.worksType = this.goodsObjList[this.goodsObjListIndex].worksType
      chargeApi.getGoodsInfo({ worksId: this.goodsObjList[this.goodsObjListIndex].worksId, worksType: this.goodsObjList[this.goodsObjListIndex].worksType }).then((res) => {
        let data = res.data.data
        if (data) {
          this.goodsObj.period = data.period
          this.goodsObj.creator = data.creator
          this.goodsObj.price = data.price
          this.goodsObj.period = data.period
          this.goodsObj.worksName = data.worksName
          this.goodsObj.secret = data.secret
        }
      })
    },
    reload() {
      this.dialogVisible = false
      window.location.reload()
    },
    onClose() {
      this.$emit('close')
    }
  },
  mounted() {
    if (this.type === 'article') {
      this.$nextTick(() => {
        if (!this.goodsObj.articlePrice) {
          this.goodsObjListIndex = 1
        }
      })
    }
  },
  destroyed() {
    clearInterval(this.statusTimer)
  }
}
</script>

<style scoped lang="scss">
.order-info-dialog {
  .el-dialog__header {
    height: 30px;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #3a3a3a;
    line-height: 30px;
    margin-bottom: 30px;
  }
  .work-info {
    display: flex;
    .cover {
      width: 160px;
      height: 217px;
      img {
        width: 100%;
      }
      margin-right: 20px;
    }
    .info {
      .title {
        font-size: 16px;
      }
      .detail {
        font-size: 14px;
        color: #3a3a3a;
        line-height: 20px;
        .red {
          color: #df5813;
        }
      }
    }
  }
  .order-info {
    .goods {
      display: flex;
      .cover {
        width: 80px;
        height: 108px;
        margin-right: 20px;
        img {
          width: 100%;
        }
      }
      margin-bottom: 10px;
    }
    .pay-option {
      img {
        height: 39px;
      }
    }
  }
  .processing {
    height: 100%;
    vertical-align: middle;
    text-align: center;
  }
  .button {
    margin-top: 30px;
    width: 100%;
    text-align: center;
    .el-button {
      padding: 5px 8px;
      width: fit-content;
      color: #fff;
      border-radius: 0;
      background-color: #df5813;
    }
    &.en {
      .el-button {
        width: 109px;
      }
    }
  }
  .button1 {
    margin-top: 10px;
    width: 100%;
    text-align: center;
    .el-button {
      padding: 5px 0;
      width: 78px;
      border-radius: 0;
      color: #df5813;
      border: solid #df5813 1px;
      &.disabled {
        border: 1px solid #999999;
        color: #999999;
      }
    }
    &.en {
      .el-button {
        width: 109px;
      }
    }
  }
  &.mobile_dialog {
    .work-info {
      height: 260px;
      .cover {
        margin-top: -80px;
      }
      .info {
        position: relative;
        .button {
          position: absolute;
          bottom: 50px;
          width: 100vw;
          left: -200px;
          &.bottom1 {
            bottom: 20px;
          }
        }
        .button1 {
          position: absolute;
          bottom: 0;
          width: 100vw;
          left: -200px;
        }
        .el-button {
          width: 140px;
          height: 40px;
        }
      }
    }
    .order-info {
      height: 300px;
      .goods {
        .cover {
          margin-top: -65px;
          width: 100px;
        }
      }
      .order {
        span {
          display: block;
          margin-bottom: 10px;
        }
      }
      .pay-option {
        span {
          display: block;
        }
      }
      .button {
        margin-top: 10px;
      }
    }
    .processing {
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      img {
        width: 100px;
      }
    }
  }
}
</style>
<style lang="scss">
.pay-option {
  .el-radio {
    margin-right: 20px;
    vertical-align: middle;
    .el-radio__label {
      display: inline-block;
    }
    .el-radio__input {
      height: 38px;
    }
  }
}
.mobile_dialog {
  overflow: hidden !important;
  height: 100%;
  display: flex;
  align-items: flex-end;
  .el-dialog {
    height: 315px;
    margin-bottom: 0;
    max-width: 100vh;
  }
  .el-dialog__header {
    height: 20px;
    background-color: #fff;
  }
  &.order {
    .el-dialog {
      height: 355px;
    }
  }
}
</style>
